var setVhHeight;

Modernizr.addTest('cssvhunit', function() {
  return Modernizr.testStyles("#modernizr { height: 50vh; }", function(elem) {
    var bool, compStyle, height;
    height = parseInt(window.innerHeight / 2, 10);
    compStyle = parseInt((window.getComputedStyle ? getComputedStyle(elem, null) : elem.currentStyle.height), 10);
    bool = (compStyle === height);
    return bool;
  });
});

setVhHeight = function() {
  var pixelHeight, vhClass;
  if (!Modernizr.cssvhunit) {
    vhClass = 'vh-';
    pixelHeight = function(element, amount) {
      var newHeight;
      newHeight = function() {
        var pixel, windowH;
        windowH = $(window).height();
        pixel = (windowH / 100) * amount;
        return element.css({
          'height': pixel + "px"
        });
      };
      $(newHeight);
      return $(window).resize(newHeight);
    };
    $.each($("[class*='" + vhClass + "']"), function() {
      var amount, currentVhClass;
      currentVhClass = $.grep(this.className.split(" "), function(v, i) {
        return v.indexOf(vhClass) === 0;
      }).join();
      amount = parseInt(currentVhClass.replace(vhClass, ''), 10);
      return pixelHeight($(this), amount);
    });
    pixelHeight($('.full-height'), 100);
    return pixelHeight($('.half-height'), 50);
  }
};

$(function() {
  return setVhHeight();
});

// ---
// generated by coffee-script 1.9.2
